// src/pages/Messages.jsx

import { useState } from "react";
import { Search, Send, MoreVertical } from "lucide-react";

export default function Messages() {
  const teams = [
    { id: 1, name: "HR Team", last: "Please update the monthly report" },
    { id: 2, name: "Recruitment", last: "Interview scheduled for 4 PM" },
    { id: 3, name: "Management", last: "Meeting moved to Tuesday" },
    { id: 4, name: "Design Team", last: "Logo approved ✔" },
  ];

  const messages = [
    { from: "HR Bot", text: "Hi! Let me know how I can help you today.", me: false },
    { from: "You", text: "Need attendance summary for today.", me: true },
    { from: "HR Bot", text: "Generating report...", me: false },
  ];

  const [selectedTeam, setSelectedTeam] = useState(teams[0]);

  return (
    <div className="h-full grid grid-cols-12 bg-gray-100 rounded-xl overflow-hidden">

      {/* ============================== */}
      {/* LEFT SIDEBAR (TEAMS LIST) */}
      {/* ============================== */}
      <div className="col-span-3 bg-white border-r flex flex-col">

        {/* Search Bar */}
        <div className="p-4 border-b">
          <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-lg">
            <Search size={18} className="text-gray-500" />
            <input
              type="text"
              placeholder="Search teams"
              className="bg-transparent w-full outline-none text-sm"
            />
          </div>
        </div>

        {/* Teams List */}
        <div className="overflow-y-auto">
          {teams.map((team) => (
            <div
              key={team.id}
              onClick={() => setSelectedTeam(team)}
              className={`p-4 cursor-pointer border-b hover:bg-gray-50 ${
                selectedTeam?.id === team.id ? "bg-blue-50" : ""
              }`}
            >
              <div className="font-semibold">{team.name}</div>
              <div className="text-sm text-gray-500">{team.last}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ============================== */}
      {/* RIGHT CHAT AREA */}
      {/* ============================== */}
      <div className="col-span-9 flex flex-col">

        {/* Header */}
        <div className="flex items-center justify-between p-4 bg-white border-b">
          <div>
            <h2 className="font-semibold text-lg">{selectedTeam.name}</h2>
            <p className="text-sm text-gray-500">Team conversation</p>
          </div>
          <MoreVertical className="text-gray-500" />
        </div>

        {/* Messages */}
        <div className="flex-1 p-6 overflow-y-auto space-y-4">

          {messages.map((msg, idx) => (
            <div
              key={idx}
              className={`max-w-md p-3 rounded-xl ${
                msg.me
                  ? "ml-auto bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-800"
              }`}
            >
              <div className="text-sm font-medium">{msg.from}</div>
              <div>{msg.text}</div>
            </div>
          ))}

        </div>

        {/* Input Bar */}
        <div className="p-4 bg-white border-t flex items-center gap-3">
          <input
            type="text"
            placeholder="Type a message..."
            className="w-full bg-gray-100 p-3 rounded-lg outline-none"
          />
          <button className="bg-blue-600 text-white p-3 rounded-lg">
            <Send size={18} />
          </button>
        </div>

      </div>
    </div>
  );
}
